














import { Vue, Component, Prop } from 'vue-property-decorator';
import AccessPointTable from '@access-control/components/tables/access-point/access-point-table.vue';
import { resourceTableFields } from '@access-control/config/access_point_options';
import AbstractField from '@shared/components/forms/inputs/abstract-field/abstract-field';
import { mixins } from 'vue-class-component';
import { BPCTableField } from '@shared/interfaces/bpc-table-interface';
import { AccessPointDefaultFilterTableInterface } from '@access-control/interfaces/access-point';

@Component({
  name: 'bc-access-point-table-input',
  components: {
    'bc-access-point-table': AccessPointTable,
  },
})
export default class AccessPointTableInput extends mixins(AbstractField) {
  // PROPS
  // LIFECYCLE
  // DATA
  // COMPUTED
  get tableFields(): BPCTableField[] {
    return resourceTableFields;
  }
  get initialFilters(): AccessPointDefaultFilterTableInterface {
    return {
      search: null,
      resource_ids: [this.formModel.id],
      status: [],
    };
  }

  // METHODS
}
